import withStyles from '@material-ui/core/styles/withStyles';
import Edit from '@material-ui/icons/Edit';
import DirectionsCar from '@material-ui/icons/DirectionsCar';
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import {

  LISTADO_PAGINACION,
} from 'config/general/Configuracion';
import AplicarSeguridad from 'conten/components/AplicarSeguridad';
import TituloPagina2 from 'conten/components/TituloPagina2';
import WaitDialog from 'conten/components/WaitDialog.jsx';
import {
  guardarPlaca,
  listarPlacas,
} from './PlacasActions';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { AddCircleTwoTone, TwoWheeler } from '@material-ui/icons';

class PlacaListar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editarPlaca: false,
      placaEditar: undefined,
      textAlertInfo: 'Un momento mientras completamos su solicitud.',
      paginacion: {
        limite: LISTADO_PAGINACION[0],
        actual: 1,
        filtro: '',
        orden: 'fh_creacion',
        sentido: 'ASC',
      },
    };
  }

  componentDidMount = () => {
    this.traerDatosServidor();
  };

  traerDatosServidor = () => {
    this.props.listarPlacas(this.state.paginacion);
  };

  editarPlaca = (placaEditar) => {
    this.setState({ placaEditar });
  };

  datosPlacaParaServidor = (placaConsulta) => {
    var placa = {
      placa: placaConsulta.placa,
      propietario: placaConsulta.propietario,
      creador: placaConsulta.creador,
      informacion: placaConsulta.informacion,
      activo: placaConsulta.activo,
      ultima_modificacion: placaConsulta.ultima_modificacion,
      id: placaConsulta.id
    };
    console.log('datos a enviar:' + placa.propietario)
    return placa;
  };

  resultadoActualizar = (_resultado, _mensaje) => {
    this.traerDatosServidor();
  };

  render() {
    const obtenerIconoVehiculo = (placa) => {
      const regexAuto = /^[A-Z]{3}[0-9]{3}$/; // Formato para carros: ABC123
      const regexMoto1 = /^[A-Z]{3}[0-9]{2}[A-Z]$/; // Formato para motos: ABC12A
      const regexMoto2 = /^[A-Z]{3}[0-9]{2}$/; // Formato alternativo para motos: ABC12
      if (regexAuto.test(placa)) {
        return { icono: <DirectionsCar /> };
      } else if (regexMoto1.test(placa) || regexMoto2.test(placa)) {
        return { icono: <TwoWheeler /> };
      }
      return { tipo: 'Desconocido', icono: null };
    };

    const { classes, placaState } = this.props;

    const { placas = [], paginacion = {}, isActivityIndicatorShown = false } =
      placaState || {};

    if (this.state.placaEditar) {
      return (
        <Redirect
          push
          to={{
            pathname: '../admin/administrar-placas',
            search: '?editar=true',
            state: {
              placa: this.datosPlacaParaServidor(this.state.placaEditar),
            },
          }}
        />
      );
    }

    return (
      <GridItem xs={12}>
        {isActivityIndicatorShown && (
          <WaitDialog text={this.state.textAlertInfo} />
        )}
        <AplicarSeguridad />
        <Card style={{ marginTop: '45px' }}>
          <CardHeader icon >
            <CardIcon
              color='primary'
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', height: '40px' }}
              onClick={() =>
                this.props.history.push('../admin/administrar-placas')
              }
            >
              <AddCircleTwoTone style={{ padding: '0px', margin: '0px', marginRight: '5px' }} />
              <b>{'Nuevo vehiculo'}</b>

            </CardIcon>

          </CardHeader>
          <CardBody>
            {placas.map((placa, index) => {
              const { icono } = obtenerIconoVehiculo(placa.placa);
              return (
                <GridContainer
                  key={placa.id || index}
                  container
                  alignItems='center'
                  display='flex'
                  justifyContent='space-evenly'
                  style={{
                    borderRadius: '5px',
                    backgroundColor: '#ffebcd',
                    marginBottom: '10px',
                    height: '50px',
                  }}

                >
                  {/* <GridItem
                   style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    xs={2} sm={2} md={2} lg={2}>
                    <Button
                      color={placa.activo ? 'green' : 'danger'}
                      simple
                      onClick={() => this.editarPlaca(placa)}
                    >
                      <Edit />
                    </Button>
                  </GridItem> */}
                  <GridItem style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}
                    xs={4} sm={4} md={2} lg={2}>
                    {placa.placa}
                  </GridItem>
                  <GridItem style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    xs={1} sm={1} md={2} lg={2}>
                    {icono}
                  </GridItem>
                  <GridItem style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}
                    xs={4} sm={4} md={2} lg={2}>
                    {placa.propietario}
                  </GridItem>

                </GridContainer>
              );
            })}
          </CardBody>
        </Card>
      </GridItem>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    placaState: state.placaState,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    listarPlacas: (paginacion) => dispatch(listarPlacas(paginacion, () => { })),
    guardarPlaca: (placa, onSuccess) =>
      dispatch(guardarPlaca(placa, onSuccess)),
  };
};
export default withStyles(extendedTablesStyle)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PlacaListar)
);